import { Typography, Grid, Box } from '@mui/material';

import {ServicesContainer, Service} from './services.styled'

export const Item = ({ icon, title }) => (
  <Service>
    <div className="service-img-container">
      <img src={require(`../../../../assets/images/${icon}`)} style={{ width: '100%' }} />
    </div>
    <Typography className="service-name">{title}</Typography>
  </Service>
)

export const Services = () => (<ServicesContainer>
  <div className="header-section">
    <Typography variant="h3" className="services-heading">Services</Typography>
    <Typography variant="h5" className="service-sub-heading">Pet Care With Love</Typography>
    <Typography variant="body2">When you are away, with Another Home, you can be confident that your pet is in the capable and caring hands. We understand your requirement for your pets, and that’s why we try our best to offer the best care and give them family like experience.</Typography>
  </div>
  <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} style={{ flex: 1 }}>
    <Grid item xs={6}>
      <Item icon={'day-care.png'} title='Day care facility' />
    </Grid>
    <Grid item xs={6}>
      <Item icon={'boarding.png'} title='Pet Boarding' />
    </Grid>
    <Grid item xs={6}>
      <Item icon={'pet-spa.png'} title='Pet Bathing' />
    </Grid>
    <Grid item xs={6}>
      <Item icon={'pet-clinic.png'} title='Pet Shop' />
    </Grid>
  </Grid>
</ServicesContainer>)



